import FBody from '@/plugins/form/FBody';
import FNumber from '@/plugins/form/FNumber';
import FInput from '@/plugins/form/FInput';
import FPrice from '@/plugins/form/FPrice';

export default class extends FBody {
  id = null;
  isDefault = false;
  tariffId = null;

  name = new FInput({
    label: 'Названия',
  });

  adult = new FNumber({
    label: 'Взрослых',
  });

  child = new FNumber({
    label: 'Детей',
  });

  age = new FNumber({
    label: 'Возраст',
    max: 18,
  });

  netto = new FPrice({
    label: 'Себестоимость',
    currency: 'RUB',
  });

  agency = new FPrice({
    label: 'Для агентства',
    currency: 'RUB',
  });

  brutto = new FPrice({
    label: 'Для клиента',
    currency: 'RUB',
  });

  constructor(props = {}) {
    super(props);
    this.setItemName();
    this.setItemAdult();
    this.setItemChild();
    this.setItemAge();
    this.setItemNetto();
    this.setItemAgency();
    this.setItemBrutto();
  }

  get data() {
    const data = super.data;

    return {
      Id: this.id,
      TariffId: this.tariffId,
      Name: data.name,
      AdultCount: data.adult,
      ChildCount: data.child,
      ChildAgeFor: data.age,
      Netto: data.netto,
      Brutto: data.brutto,
      Commission: data.agency - data.netto,
      Charge: data.brutto - data.agency,
      IsDefault: this.isDefault,
    };
  }

  set data(data) {
    this.id = data?.Id || null;
    this.tariffId = data.TariffId || `f${(Math.ceil(Math.random() * 1e8)).toString(16)}t${Date.now()}`;
    this.name.set(data.Name || '');
    this.adult.set(data.AdultCount || 0);
    this.child.set(data.ChildCount || 0);
    this.age.set(data.ChildAgeFor || 14);
    this.netto.set(data.Netto || 0);
    this.brutto.set(data.Brutto || 0);
    this.agency.set(data.Netto + data.Commission || 0);
    this.isDefault = data.IsDefault || false;
  }

  set(value = {}) {
    this.id = value.id || null;
    this.tariffId = value.tariffId || `f${(Math.ceil(Math.random() * 1e8)).toString(16)}t${Date.now()}`;
    this.__set('name', value.name, '');
    this.__set('adult', value.adult, 0);
    this.__set('child', value.child, 0);
    this.__set('age', value.age, 16);
    this.__set('netto', value.netto, 0);
    this.__set('agency', value.agency, 0);
    this.__set('brutto', value.brutto, 0);
    this.isDefault = value.isDefault || false;
    return this;
  }

  setItemName() {
    this.setItem('name', this.name);
  }

  setItemAdult() {
    this.setItem('adult', this.adult);
  }

  setItemChild() {
    this.setItem('child', this.child);
  }

  setItemAge() {
    this.setItem('age', this.age);
  }

  setItemNetto() {
    this.setItem('netto', this.netto);
  }

  setItemAgency() {
    this.setItem('agency', this.agency);
  }

  setItemBrutto() {
    this.setItem('brutto', this.brutto);
  }
}
